// src/modules/hr/routes.jsx — HR & Administration module routes
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import HrDashboard from './pages/HrDashboard';
import EmployeeList from './pages/EmployeeList';
import EmployeeProfile from './pages/EmployeeProfile';
import AssetManagement from './pages/AssetManagement';
import HolidayCalendar from './pages/HolidayCalendar';
import AttendanceManagement from './pages/AttendanceManagement';
import LeaveManagement from './pages/LeaveManagement';
import EmployeeDocuments from './pages/EmployeeDocuments';
import PerformanceManagement from './pages/PerformanceManagement';
import PayrollPreparation from './pages/PayrollPreparation';
import ExitManagement from './pages/ExitManagement';
import HrReports from './pages/HrReports';

const HrRoutes = () => (
  <Routes>
    <Route index element={<HrDashboard />} />
    <Route path="dashboard" element={<HrDashboard />} />
    <Route path="employees" element={<EmployeeList />} />
    <Route path="employees/:id" element={<EmployeeProfile />} />
    <Route path="assets" element={<AssetManagement />} />
    <Route path="holidays" element={<HolidayCalendar />} />
    <Route path="attendance" element={<AttendanceManagement />} />
    <Route path="leave" element={<LeaveManagement />} />
    <Route path="documents" element={<EmployeeDocuments />} />
    <Route path="performance" element={<PerformanceManagement />} />
    <Route path="payroll" element={<PayrollPreparation />} />
    <Route path="exits" element={<ExitManagement />} />
    <Route path="reports" element={<HrReports />} />
    <Route path="*" element={<Navigate to="/hr" replace />} />
  </Routes>
);

export default HrRoutes;
